export default __webpack_public_path__ + "static/media/ag-img.4e2609b6.png";